import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-delete-fine-warning",
	templateUrl: "./delete-fine-warning.component.html",
	styleUrls: ["./delete-fine-warning.component.css"],
})
export class DeleteFineWarningComponent implements OnInit {
	constructor(public ref: DynamicDialogRef) {}

	ngOnInit(): void {}

	///////////////////////////////
	// Buttons
	///////////////////////////////
	onYes() {
		this.ref.close(1);
	}

	onNo() {
		this.ref.close(-1);
	}
}
